<template>
  <div class="share">
    <div v-if="account&&account.id" class="containter tac">
      <div class="tit df aic jcc">
        <div class="line"></div>
        分享得佣金&nbsp;&nbsp;&nbsp;收益看得见
        <div class="line"></div>
      </div>
      <div class="ewmb">
        <img :src="ewm" alt="" class="ewm">
        <div v-if="!(account.huiyuan_expire_at&&account.huiyuan_time>0)" class="pops df aic">
          <div class="txtb">
            您的会员已到期，未续费期间无法享受邀请提成，若30天内未续费，系统会解除您的邀请关系
          </div>
        </div>
      </div>
      <div :class="account.huiyuan_expire_at&&account.huiyuan_time>0?'':'op0'" class="txt2 c_fff ">我的邀请码：{{account.code}}</div>
      <div class="txt3 c_fff">分享二维码邀请好友，好友进行消费即有提成!</div>
      <div @click="sharetips" class="btn btn1 df aic"><img src="./assets/img/sb1.png" alt="" class="ico">分享邀请好友</div>
      <div :class="account.huiyuan_expire_at&&account.huiyuan_time>0?'':'op0'" class="btn btn2 df aic"><img src="./assets/img/sb2.png" alt="" class="ico">长按保存二维码<img :src="ewm" alt="" class="ewmimg"></div>
      <div class="box1 c_fff">
        <div class="sd sd1"></div>
        <div class="sd sd2"></div>
        <div class="sd sd3"></div>
        <div class="sd sd4"></div>
        <div class="sd sd5"></div>
        <div class="item df aic">
          <div class="num">1</div>
          <div class="rtxt fx1 tal">邀请好友加入</div>
        </div>
        <div class="item df aic">
          <i></i>
          <div class="num">2</div>
          <div class="rtxt fx1 tal">所邀请好友成功下单</div>
        </div>
        <div class="item df aic">
          <i></i>
          <div class="num">3</div>
          <div class="rtxt fx1 tal">获得分销奖励</div>
        </div>
      </div>
      <div class="box2 tal">
        <div class="t1">会员分销规则</div>
        <div class="">
          1、分销资格只针对年费会员开放；<br>
          2、年费会员可将分销中心二维码或邀请码通过微信或钉钉等方式分发给其他用户；<br>
          3、所分销对象需成为年费会员方可享受分销对象的服务消费提点；<br>
          4、请保持年费会员资格，未续费超1月则会取消与下级会员之间的分销关系；<br>
          5、下级会员如未续费成为年费会员，则上级会员不享受其服务消费提点；<br>
          6、本分销为二级，仍可获得一级分销会员所分销的会员消费提点；<br>
          7、分销所得提点可通过微信或支付宝提现，提现周期为48小时；<br>
          8、分销会员不得从事与衣印经营范围相违背的分销活动。
        </div>
        <div class="t1">分销对象规则</div>
        <div>
          1、会员到期后1个月内未续费，将终止分销提点；<br>
          2、会员到期后1个月内续费，恢复自到期后第二天开始计算的洗涤提成金额，但不会恢复未续费时所产生的洗涤提成金额；<br>
          3、到期后不显示洗涤金额提成，1个月期限内续费可恢复，超过续费时间则无法恢复。续费后获取佣金，标记冻结期；<br>
          4、超过1个月续费，原有会员关系归零，客户直接由平台管理。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import weui from 'weui.js'
export default {
  data() {
    return {
      account: {},
      ewm: ''
    }
  },
  mounted() {
    this.getAccount();
  },
  methods: {
    getAccount() {
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
        // // //test
        //     //   vm.account.honor = 3;
        // vm.account.huiyuan_expire_at = ''//未开通会员
        // vm.account.huiyuan_expire_at = '2021-12-06 22:22:22'//会员中
        // vm.account.huiyuan_expire_at = '2020-12-06 22:22:22'//会员过期
        // //test
        if (vm.account.huiyuan_expire_at) {
          let huiyuan_time = new Date(vm.account.huiyuan_expire_at.replace(/-/g, '/')).getTime() - new Date().getTime();
          vm.account.huiyuan_time = huiyuan_time;//>0标示有会员
        }
        vm.getQr();
        vm.getjsapi();
      })
    },
    getQr() {
      this.ewm = API_URL + "qr/invite?id=" + this.account.id
    },
    getjsapi() {
      let vm = this;
      console.log(localStorage.getItem('shareUrl'))
      let href = localStorage.getItem('shareUrl');
      let url = encodeURIComponent(href)
      vm.ajax("wechat/jsdk", "get", 'url=' + url, e => {
        let data = e.data;
        console.log(data);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.app_id, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonce_str, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名
          jsApiList: [
            // 'getLocation',
            // 'scanQRCode',
            // 'openLocation',
            'updateAppMessageShareData',
            'updateTimelineShareData'
          ] // 必填，需要使用的JS接口列表
        });
        vm.share();
      })
    },
    share() {
      let vm = this;
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        let title = "衣印";
        let desc = "恋他，就为他洗衣！";
        let logo = require('./assets/img/logo.jpg');
        let time = new Date().getTime();
        let shareurl = window.location.href.split('#')[0] + '#/register?code=' + vm.account.code + '&time=' + time;
        console.log('shareurl', shareurl);
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: logo, // 分享图标
          success: function () {
            // 设置成功
          }
        })
        wx.updateTimelineShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: logo, // 分享图标
          success: function () {
            // 设置成功
          }
        })
      });
    },
    sharetips() {
      weui.topTips('点击右上角分享给朋友')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/share.vue